<mobi-breadcrumb />
<div class="service-hero">
  <div class="hero-right-image">
    <div class="mobi-ui-grid is-align-center mobi-ui-margin-y-md">
      <div
        class="mobi-ui-col-1/1 md:mobi-ui-col-9/16 lg:mobi-ui-col-1/2 xl:mobi-ui-col-6/16 xl:mobi-ui-offset-2/16"
      >
        <mobi-hero-text
          [superTitle]="entity().superTitle"
          [subtitle]="entity().subTitle"
          [title]="entity().title"
          [lead]="entity().lead"
          [contentLinks]="contentLinks()"
          [fullWidth]="true"
          [primaryCta]="entity().primaryCta | extractUrl"
          [primaryCtaTarget]="entity().primaryCta?.options?.attributes?.target"
          [primaryCtaIcon]="entity().primaryCtaIcon"
          [secondaryCta]="entity().secondaryCta | extractUrl"
          [secondaryCtaIcon]="entity().secondaryCtaIcon"
          [secondaryCtaTarget]="entity().secondaryCta?.options?.attributes?.target"
          [primaryCtaTitle]="entity().primaryCta?.title"
          [secondaryCtaTitle]="entity().secondaryCta?.title"
        />
      </div>
      <div
        class="self-start mobi-ui-col-1/1 md:mobi-ui-col-7/16 lg:mobi-ui-col-5/12 lg:mobi-ui-offset-1/12 xl:mobi-ui-col-5/16 xl:mobi-ui-offset-1/16"
      >
        <div class="hero-image-animation-wrapper">
          @defer (hydrate never) {
            <mobi-media
              [animation]="false"
              class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
              [entity]="entity().headerImage"
              rounded="left"
              responsiveStyle="hero_square"
              [lazy]="false"
            />
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (entity().paragraphs) {
  <div class="page-content is-background">
    @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
      @if (paragraph) {
        <mobi-paragraph-loader
          [bundle]="paragraph.type"
          [data]="{ paragraph: paragraph }"
        />
      }
    }

    @defer (hydrate on viewport) {
      @if (entity().showContact) {
        <div class="content-section is-background">
          <div>
            <mobi-concierge />
          </div>
        </div>
      }
    }
  </div>
}
